<template>
  <div class="app d-flex flex-column"
  v-loading.fullscreen.lock="isGlobalLoading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
  >
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
import { datadogRum } from '@datadog/browser-rum';
import { nationals } from './utils/constants';

const defaultLayout = 'app-layout';

export default {
  data() {
    return {
      national: +process.env.VUE_APP_NATIONAL_ID,
      nationals,
    };
  },
  mounted() {
    const datadogUser = datadogRum.getUser();
    if (!datadogUser?.id || !datadogUser?.email) {
      const userId = this.$store.getters['user/userId'];
      const userProfile = this.$store.getters['user/profile'];
      if (userId && userProfile?.email) {
        datadogRum.setUser({
          id: userId,
          name: `${userProfile.firstName} ${userProfile.lastName}`,
          email: userProfile.email,
        });
      }
    }
  },
  created() {
    this.$store.dispatch('national/setInitialMode');
    const nationalName = this.nationals[this.national];
    const capitalizedNationalName = nationalName === 'eagletag' ? 'Get Tagg\'d' : nationalName.charAt(0).toUpperCase() + nationalName.slice(1);
    document.title = `${capitalizedNationalName} | Assemble Sports Portal `;
  },
  computed: {
    layout() {
      return `${(this.$route.meta.layout || defaultLayout)}`;
    },
    isGlobalLoading() {
      return this.$store.state.globalLoading;
    },
    loadingText() {
      return this.$store.state.loadingText;
    },
  }
};
</script>

<style lang="scss">
.app {
  font-family: $fontRegular;
  // color: $primary;
  height: 100%;
}

h1 {
  font-family: $fontRegular;
  // color: $primary;
}
</style>
